import React, { useState } from "react";
import Banner from "../components/banner/Banner";
import Contact from "../components/contact/Contact";
import FloatingButton from "../components/bottomtotop/FloatingButton";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import { TbApi, TbSparkles } from "react-icons/tb";
import prizelistImg from "../../assets/images/3d-rendering-laptop.png";

import {
  FaBabyCarriage,
  FaBell,
  FaBolt,
  FaBoltLightning,
  FaBowlFood,
  FaBoxesPacking,
  FaBoxesStacked,
  FaChartLine,
  FaClipboardList,
  FaCubes,
  FaFileArrowDown,
  FaHandshake,
  FaNetworkWired,
  FaPassport,
  FaPersonBooth,
  FaProductHunt,
  FaShieldDog,
  FaShieldHalved,
  FaShop,
  FaSprayCanSparkles,
  FaStar,
  FaSuitcase,
  FaTableCells,
  FaTags,
  FaToolbox,
  FaUserDoctor,
} from "react-icons/fa6";

import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import avatar1 from "../../assets/images/avatar-1.png";
import avatar2 from "../../assets/images/avatar-2.png";
import avatar3 from "../../assets/images/avatar-3.png";
import avatar4 from "../../assets/images/avatar-4.png";
import avatar5 from "../../assets/images/avatar-5.png";
import image1 from "../../assets/images/1-1.png";
import image2 from "../../assets/images/1-2.png";
import image3 from "../../assets/images/backgound_img.jpg";
import client1 from "../../assets/images/client1.png";
import client2 from "../../assets/images/client2.png";
import client3 from "../../assets/images/client3.png";
import client4 from "../../assets/images/client4.png";
import client5 from "../../assets/images/client5.png";
import client6 from "../../assets/images/client6.png";
import client7 from "../../assets/images/client7.png";
import client8 from "../../assets/images/client8.png";
import client9 from "../../assets/images/client9.png";
import client10 from "../../assets/images/client10.png";
import client11 from "../../assets/images/client11.png";
import stepline from "../../assets/images/step-line.png";
import stepline2 from "../../assets/images/step-line-2.png";
import step1 from "../../assets/images/step-1.png";
import stepimg1 from "../../assets/Image/Signup.png";
import stepimg2 from "../../assets/Image/products.png";
import step2 from "../../assets/images/step-2.png";
import step3 from "../../assets/images/step-3.png";
import stepimg3 from "../../assets/Image/order_page (1).png";
import testibg from "../../assets/images/testi-bg.svg";
import quote from "../../assets/images/quote.png";
import seller_image from "../../assets/Docs/seller_image.png";
import buyer_images from "../../assets/Docs/buyer_images.png";

const GlobleComponent = () => {
  // const clientLogos = [
  //   client1,
  //   client2,
  //   client3,
  //   client4,
  //   client5,
  //   client6,
  //   client7,
  //   client8,
  //   client9,
  //   client10,
  //   client11,
  // ];

  const crmfeatures = [
    {
      title: "Instant Setup",
      description:
        "Start in minutes with Selzor’s easy setup and begin taking B2B orders effortlessly.",
      icon: <FaBoltLightning />,
    },
    {
      title: "Pricing Tiers",
      description: "Easily set and display custom prices for each buyer group.",
      icon: <FaTags />,
    },
    {
      title: "Custom Fields",
      description: "Add custom fields to fit your needs for buyers and orders.",
      icon: <FaTableCells />,
    },
    {
      title: "Easy Order Downloads",
      description:
        "Export orders instantly in XLS, PDF, JSON, or XML—no manual entry needed.",
      icon: <FaFileArrowDown />,
    },
    {
      title: "Real-Time Alerts",
      description:
        "Get instant mobile alerts for every new order so you never miss a sale.",
      icon: <FaBell />,
    },
    {
      title: "Instant Reports & Insights",
      description:
        "Get one-click real-time reports to plan production, purchasing, and inventory.",
      icon: <FaChartLine />,
    },
    {
      title: "Enterprise-Grade Security",
      description: "our data is secure on Selzor’s encrypted AWS servers.",
      icon: <FaShieldHalved />,
    },
    {
      title: "Live Stock Visibility",
      description:
        "Keep reps and buyers updated with real-time stock availability.",
      icon: <FaBoxesStacked />,
    },
    {
      title: "Seamless API Integration",
      description:
        "Selzor to your accounting, ERP, or inventory system via REST API.",
      icon: <TbApi />,
    },
  ];

  const courseCategories = [
    { name: "Food & Beverages", imgSrc: <FaBowlFood /> },
    { name: "Personal Care & Cosmetics", imgSrc: <FaSuitcase /> },
    { name: "Home & Kitchen Essentials", imgSrc: <FaShop /> },
    { name: "Electronics & Appliances", imgSrc: <FaBolt /> },
    { name: "Clothing & Apparel", imgSrc: <FaPersonBooth /> },
    { name: "Footwear & Accessories", imgSrc: <FaCubes /> },
    { name: "Health & Wellness", imgSrc: <FaUserDoctor /> },
    { name: "Stationery & Office Supplies", imgSrc: <FaNetworkWired /> },
    { name: "Automotive Parts & Accessories", imgSrc: <FaSprayCanSparkles /> },
    { name: "Hardware & Tools", imgSrc: <FaToolbox /> },
    { name: "Agricultural Products", imgSrc: <FaProductHunt /> },
    { name: "Baby & Kids Products", imgSrc: <FaBabyCarriage /> },
    { name: "Pet Supplies", imgSrc: <FaShieldDog /> },
    { name: "Sports & Outdoor", imgSrc: <FaPassport /> },
  ];

  const testimonials2 = [
    {
      name: "Sales Representative",
      role: "",
      image: avatar1,
      text: "With Selzor’s intuitive interface, taking orders at the client’s location has never been easier. I no longer need to carry around outdated price lists. A quick search gives me all the info I need in seconds.",
    },
    {
      name: " B2B Buyer",
      role: "",
      image: avatar2,
      text: "With Selzor, I can place orders anytime - day or night - without phone calls or emails. I get instant updates on new products, pricing, offers, and my order status. It’s smooth, fast, and reliable.",
    },
    {
      name: " Wholesale Seller",
      role: "",
      image: avatar3,
      text: "Thanks to Selzor’s powerful reports and seamless API integration, we can forecast production and purchases accurately. The order-taking process is now completely streamlined.",
    },
    {
      name: "Store Manager",
      role: "",
      image: avatar4,
      text: "Selzor’s one-click itemized quantity reports give us instant clarity on product and size totals across orders. It’s saved us hours and made our order packing extremely efficient.",
    },
  ];

  const faqs = [
    {
      question: "What is a 'Seller' on Selzor?",
      answer:
        "A 'Seller' refers to any company or business that signs up on Selzor to accept B2B orders from their customers — such as distributors, dealers, or retailers. Upon registration, Sellers are automatically enrolled in our Free Plan, and can upgrade to any of our paid plans at any time for advanced features and higher limits.",
    },
    {
      question: "Who is considered a 'Buyer' on Selzor?",
      answer:
        "A 'Buyer' is any business entity that uses Selzor to place orders to their suppliers. This can include your retailers, dealers, wholesalers, or any business customers. Selzor is completely free for Buyers, and they can place orders 24/7 using web or mobile apps.",
    },
    {
      question: "What does 'User' mean in the context of Selzor?",
      answer:
        "There are two types of Users: Free and Paid. A Paid User is anyone managing a Seller account (like an Admin, Sales Rep, or Distributor). A Free User is someone managing a Buyer account. Each Buyer account includes 5 free user logins, while Seller accounts depend on the plan you're on.",
    },
    {
      question:
        "Do I need to sign up separately for Selzor Web and Mobile apps?",
      answer:
        "No. You only need to sign up once. The same credentials give you access to Selzor’s Web App and Mobile Apps (available on both Android and iOS).",
    },
    {
      question:
        "Do I need separate logins to become a Seller or Buyer on Selzor?",
      answer:
        "No. You can use the same login to register as a Seller or a Buyer — or even switch between roles. Selzor lets you manage both sides of the order process with a single account.",
    },
    {
      question:
        "Can I manage multiple Sellers and Buyers from the same account?",
      answer:
        "Yes. Selzor supports multiple Seller and Buyer accounts under a single login. Currently, you can add multiple Buyers freely. To add more than one Seller, your existing Seller account must be on a paid plan.",
    },
    {
      question: "What features are included in the Selzor Free Plan?",
      answer:
        "The Free Plan includes 1 Seller, 1 User, 25 orders per month, 5 Buyers, up to 1000 SKUs, and 5 Custom Order Fields. Once the 25 monthly order limit is reached, no new orders can be received until the next 30-day cycle begins, based on your signup date.",
    },
    {
      question: "Does the Free Plan expire?",
      answer:
        "No. The Selzor Free Plan currently has no expiration limit. You can continue using it for as long as you like. If there are any changes in the future, we’ll inform you in advance.",
    },
    {
      question: "What are 'Custom Order Fields' in Selzor?",
      answer:
        "Custom Order Fields let you personalize the order form to collect additional information from Buyers at the time of order submission or completion — such as delivery date, PO number, or custom notes.",
    },
    {
      question: "What is a 'Custom App Code'?",
      answer:
        "When you sign up as a Seller, Selzor assigns you a unique 8-digit App Code that Buyers use to connect and place orders. With our Business and Business Plus plans, you can replace this code with your own branded custom code for easier recognition and a professional touch.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  return (
    <div>
      <Header />
      <Banner />
      <section className="overflow-hidden py-4 pt-6 bg-white relative">
        <style>
          {`
            @keyframes logo-marquee {
              0% { transform: translateX(0%); }
              100% { transform: translateX(-50%); }
            }

            .animate-logo-marquee {
              animation: logo-marquee 50s linear infinite;
            }
          `}
        </style>

        {/* <div className="flex gap-8 whitespace-nowrap animate-logo-marquee">
          {[...clientLogos, ...clientLogos].map((logo, index) => (
            <div key={index} className="flex-shrink-0">
              <img
                src={logo}
                alt={`Client ${index}`}
                className="h-28 w-auto p-4"
              />
            </div>
          ))}
        </div> */}
      </section>

      <section>
        <div className="mx-auto max-w-7xl pt-20 px-4 sm:px-6 lg:px-0">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="basis-full sm:basis-6/12">
                <div className="flex flex-col gap-5 justify-between h-full">
                  <div className="animate-y delay-reset flex flex-col gap-2 sm:gap-3">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3 text-start">
                      Centralized Product. Modular Solutions.
                    </h2>
                    <h6 className="text-gray-600 text-base sm:text-lg text-start">
                      A unified platform designed to adapt, scale, and solve
                      diverse challenges through flexible, plug-and-play
                      modules.
                    </h6>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full sm:basis-1/2">
                      <div className="p-3 sm:p-4 md:p-6 flex flex-col items-start h-full gap-5 sm:gap-8">
                        <div className="w-[60px] h-[60px] bg-[#b9ece6] rounded-full flex items-center justify-center">
                          <FaClipboardList className="text-2xl leading-none text-[#2E847A]" />
                        </div>
                        <div className="flex flex-col gap-2 sm:gap-3 grow">
                          <h4 className="text-2xl text-start">
                            Go paperless with on-the-go order entry.
                          </h4>
                          <p className=" text-gray-600 text-justify">
                            Give sales reps a mobile solution to take orders
                            instantly, access live product data, and close deals
                            faster - without paperwork or outdated catalogue.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full sm:basis-1/2">
                      <div className="p-3 sm:p-4 md:p-6 flex flex-col items-start h-full gap-5 sm:gap-8">
                        <div className="w-[60px] h-[60px] bg-[#b9ece6] rounded-full flex items-center justify-center">
                          <FaHandshake className="text-2xl leading-none text-[#2E847A]" />
                        </div>
                        <div className="flex flex-col gap-2 sm:gap-3 grow">
                          <h4 className="text-2xl text-start">
                            Custom B2B Portals with a B2C Feel
                          </h4>
                          <p className="text-justify text-gray-600">
                            Let buyers order anytime through a sleek
                            self-service portal, with tailored pricing, product
                            access, and no need for calls or printed lists.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="basis-full sm:basis-6/12">
                <div className="animate-y-down rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden flex flex-col h-full">
                  <div className="p-4 sm:p-6 md:p-8 lg:p-10 min-h-full h-[300px] sm:h-[400px] md:h-[530px]">
                    <div
                      className="h-full lg:rounded-l-xl rtl:rounded-r-xl bg-center bg-contain bg-no-repeat"
                      style={{ backgroundImage: `url(${image1})` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="basis-full sm:basis-6/12">
                <div className="animate-y-down pt-8 sm:pt-14 rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden flex flex-col items-center gap-4 sm:gap-6 h-full">
                  <div className="flex flex-col items-center gap-2 px-4 sm:px-0">
                    <div className="flex flex-col items-center gap-1 dir">
                      <div className="flex -space-x-[14px] *:w-[42px] *:h-[42px] *:rounded-full *:border *:border-theme-bg-paper">
                        <img src={avatar1} alt="img" className="z-40" />
                        <img src={avatar2} alt="img" className="z-30" />
                        <img src={avatar3} alt="img" className="z-20" />
                        <img src={avatar4} alt="img" className="z-10" />
                        <img src={avatar5} alt="img" className="z-0" />
                      </div>
                      <h6 className="subtitle2 text-sm sm:text-base">
                        10k+ Reviews (4.5 out of 5)
                      </h6>
                    </div>
                    <div className="text-[#2E847A]">
                      <svg
                        className="w-[92px] md:w-[122px] h-auto"
                        viewBox="0 0 122 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5V5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5V5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5V5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5V5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5V5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5V5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5V5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5V5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
                          stroke="currentColor"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div
                    className="h-[180px] sm:h-[241px] md:h-[352px] w-full scale-[1.2] sm:scale-[1.3] origin-top bg-cover bg-center bg-no-repeat relative"
                    style={{ backgroundImage: `url(${image2})` }}
                  >
                    <div className="absolute inset-0 "></div>
                  </div>
                </div>
              </div>
              <div className="basis-full sm:basis-6/12">
                <div className="flex flex-col gap-3 justify-between h-full">
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full sm:basis-1/2">
                      <div className="p-3 sm:p-4 md:p-6 flex flex-col items-start h-full gap-5 sm:gap-8">
                        <div className="w-[60px] h-[60px] bg-[#b9ece6] rounded-full flex items-center justify-center">
                          <FaNetworkWired className="text-2xl leading-none text-[#2E847A]" />
                        </div>
                        <div className="flex flex-col gap-2 sm:gap-3 grow">
                          <h4 className="text-2xl text-start">
                            Centralize and Automate Your Order Flow
                          </h4>
                          <p className="text-justify text-gray-600">
                            Manage all orders from one dashboard with real-time
                            insights, faster processing, and seamless All
                            ERP/accounting integration.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full sm:basis-1/2">
                      <div className="p-3 sm:p-4 md:p-6 flex flex-col items-start h-full gap-5 sm:gap-8">
                        <div className="w-[60px] h-[60px] bg-[#b9ece6] rounded-full flex items-center justify-center">
                          <FaBoxesPacking className="text-2xl leading-none text-[#2E847A]" />
                        </div>
                        <div className="flex flex-col gap-2 sm:gap-3 grow">
                          <h4 className="text-2xl text-start">
                            Your Digital Product catalogue, Reimagined
                          </h4>
                          <p className="text-justify text-gray-600">
                            Showcase products with rich visuals, categories, and
                            smart search, letting customers order directly in
                            your preferred format—XLS, PDF, JSON, or XML.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden">
                    <div className="p-4 sm:p-6 md:p-8 flex flex-col items-start h-full gap-6 sm:gap-14">
                      <h6 className="text-start text-xl sm:text-2xl text-gray-600">
                        A Complete B2B Ordering Platform Connecting Brands,
                        Distributors, Wholesalers, Dealers & Retailers.
                      </h6>
                      <a
                        href="/features"
                        className="bg-[#1a9588] rounded-full text-white text-sm hover:bg-[#28b5a6] hover:shadow-xl py-3 font-semibold px-6 capitalize"
                      >
                        <span className="flex items-center gap-2 lg:-ml-1 rtl:-mr-1">
                          <TbSparkles className="text-base leading-none" />
                          Explore all Features
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl pt-10 sm:pt-10 md:pt-20 py-10 sm:py-12 md:py-16">
        <div className="container mx-auto px-4 bg-[#dbf4f1]">
          <div className="relative animate-y delay-reset px-6 sm:px-10 md:px-16 py-6 sm:py-10 md:py-16 rounded-3xl sm:rounded-[32px] md:rounded-[40px] overflow-hidden">
            {/* Background Image with opacity */}
            <img
              src={image3}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover opacity-5"
            />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center gap-6 text-center">
              <div className="flex flex-col gap-2">
                <h2 className="text-2xl sm:text-3xl md:text-5xl pb-3 font-semibold text-black">
                  {/* CRM Unleashed: Build Connections, Drive Engagement, Achieve
                  Success */}
                  Buyer-Led Ordering: Enable Sales, Empower Buyers, Accelerate Business
                </h2>
                <h6 className=" text-lg sm:text-xl mx-auto max-w-2xl text-gray-700">
                  With advanced analytics and reporting, you can track customer
                  behavior, sales trends, and more - enabling smarter,
                  data-driven decisions.
                </h6>
              </div>

              <div className="flex flex-row items-center justify-center py-6 sm:py-4 md:py-8 gap-6 sm:gap-12">
                <div className="flex flex-col items-center gap-2 w-40 sm:w-[246px] text-center">
                  <div className="flex flex-row items-center text-4xl sm:text-6xl font-semibold text-gray-800 pb-2">
                    <span>90</span>
                    <span>%</span>
                  </div>
                  <p className=" text-sm sm:text-base text-gray-700">
                    Smart Navigation and Streamlined Communication
                  </p>
                </div>

                <div className="h-auto self-stretch border-l border-gray-300"></div>

                <div className="flex flex-col items-center gap-2 w-40 sm:w-[246px] text-center">
                  <div className="flex flex-row items-center text-4xl sm:text-6xl font-semibold text-gray-800 pb-2">
                    <span>10</span>
                    <span>x</span>
                  </div>
                  <p className=" text-sm sm:text-base text-gray-700">
                    Achieving faster sales through streamlined processes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col gap-6 sm:gap-8">
            <div className="text-start">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
                Explore Smart, Scalable Sales Enablement
              </h2>
              <p className="text-gray-600 text-base sm:text-lg">
                Streamline Every Step with 50+ Advanced Ordering Features
              </p>
            </div>

            <div className="grid grid-cols-12 gap-3">
              {crmfeatures.map((feature, index) => (
                <div
                  key={index}
                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                >
                  <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full">
                    <div className="relative p-6 sm:p-8 md:p-10 flex flex-col items-start h-full gap-8 sm:gap-8 md:gap-8">
                      <div className="bg-[rgba(7,_166,_152,_0.6)] filter blur-[75px] w-[151px] h-[151px] absolute -top-[80px] -right-[100px]"></div>
                      <span className="text-5xl text-[#1a9588] bg-white rounded-full p-5">
                        {feature.icon}
                      </span>

                      <div className="flex flex-col text-start gap-2 sm:gap-3">
                        <h4 className="text-2xl">{feature.title}</h4>
                        <p className="text-lg text-gray-700">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 sm:pb-24 lg:pb-32 px-4 sm:px-6 lg:px-8 relative">
        <div className="bg-[linear-gradient(180deg,_rgba(7,_166,_152,_0)_0%,_rgba(7,_166,_152,_0.39)_100%)] filter blur-[300px] absolute w-full max-w-[1200px] h-[1330px] -top-3/5 left-1/2 transform -translate-x-1/2"></div>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 lg:mb-16">
            <h4 className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
              Learning Steps
            </h4>
            <h2 className="text-gray-600 text-sm xs:text-base sm:text-lg max-w-3xl mx-auto mb-4 sm:mb-6 lg:mb-8 xl:mb-10">
              Assess, Learning & Get Certified
            </h2>
          </div>

          <div className="step-items-wrap">
            <div className="step-item-21 flex flex-col lg:flex-row items-center relative mb-20 sm:mb-32 lg:mb-52">
              <div className="step-shape-1 absolute bottom-[-120px] sm:bottom-[-150px] lg:bottom-[-180px] left-[50%] lg:left-[40%] transform -translate-x-1/2 z-[-1]">
                <img
                  src={stepline}
                  alt="line"
                  className="w-full h-auto max-h-[80px] sm:max-h-[100px] lg:max-h-none"
                />
              </div>

              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-2 lg:order-1 mt-6 lg:mt-0">
                <div className="step-content">
                  <div className="step-inner grid items-center grid-cols-[80px_1fr] sm:grid-cols-[100px_1fr] lg:grid-cols-[120px_1fr] gap-3 sm:gap-4 lg:gap-5 mb-6 sm:mb-7 lg:mb-9">
                    <div className="icon bg-white border border-[#E0E5EB] shadow-[0px_14px_60px_rgba(20,71,67,0.22)] flex items-center justify-center h-[80px] w-[80px] sm:h-[100px] sm:w-[100px] lg:h-[120px] lg:w-[120px] rounded-full">
                      <img
                        src={step1}
                        alt="icon"
                        className="w-10 sm:w-12 lg:w-auto"
                      />
                    </div>
                    <h2 className="number text-[#398a83] text-start  text-[40px] sm:text-[50px] lg:text-[60px] font-bold leading-none">
                      Step 01
                    </h2>
                  </div>
                  <h3 className="text-xl sm:text-2xl text-start mb-3 sm:mb-4 lg:mb-5">
                    Sign-Up & catalogue Access
                  </h3>
                  <p className="mb-0 text-start text-gray-600 text-sm sm:text-base max-w-full lg:max-w-[502px]">
                    Buyers and sales reps sign up on the Selzor platform. Once
                    verified, they receive secure login credentials to access
                    personalized product catalogue, pricing, and order tools.
                    User roles and permissions ensure a tailored experience from
                    the start.
                  </p>
                </div>
              </div>

              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-1 lg:order-2">
                <div className="step-img max-w-full lg:max-w-[628px] w-full h-[240px] sm:h-[320px] lg:h-[400px] rounded-xl sm:rounded-2xl lg:rounded-3xl shadow-[0px_11px_51px_rgba(19,83,77,0.22)]">
                  <img
                    src={stepimg1}
                    alt="step-1"
                    className="w-full h-full object-cover rounded-xl sm:rounded-2xl lg:rounded-3xl border-4 sm:border-6 border-white"
                  />
                </div>
              </div>
            </div>

            <div className="step-item-21 flex flex-col lg:flex-row items-center relative mb-20 sm:mb-32 lg:mb-52">
              <div className="step-shape-1 absolute bottom-[-120px] sm:bottom-[-150px] lg:bottom-[-180px] left-[50%] lg:left-[40%] transform -translate-x-1/2 z-[-1]">
                <img
                  src={stepline2}
                  alt="line"
                  className="w-full h-auto max-h-[80px] sm:max-h-[100px] lg:max-h-none"
                />
              </div>

              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-1">
                <div className="step-img max-w-full lg:max-w-[628px] w-full h-[240px] sm:h-[320px] lg:h-[400px] rounded-xl sm:rounded-2xl lg:rounded-3xl shadow-[0px_11px_51px_rgba(19,83,77,0.22)]">
                  <img
                    src={stepimg2}
                    alt="step-2"
                    className="w-full h-full object-cover rounded-xl sm:rounded-2xl lg:rounded-3xl border-4 sm:border-6 border-white"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-2 mt-6 lg:mt-0 lg:pl-4 xl:pl-9">
                <div className="step-content">
                  <div className="step-inner grid items-center grid-cols-[80px_1fr] sm:grid-cols-[100px_1fr] lg:grid-cols-[120px_1fr] gap-3 sm:gap-4 lg:gap-5 mb-6 sm:mb-7 lg:mb-9 pl-4 sm:pl-6 lg:pl-9">
                    <div className="icon bg-white border border-[#E0E5EB] shadow-[0px_14px_60px_rgba(20,71,67,0.22)] flex items-center justify-center h-[80px] w-[80px] sm:h-[100px] sm:w-[100px] lg:h-[120px] lg:w-[120px] rounded-full">
                      <img
                        src={step2}
                        alt="icon"
                        className="w-10 sm:w-12 lg:w-auto"
                      />
                    </div>
                    <h2 className="number text-[#398a83] text-start  text-[40px] sm:text-[50px] lg:text-[60px] font-bold leading-none">
                      Step 02
                    </h2>
                  </div>
                  {/* <h3 className="text-xl sm:text-2xl text-start mb-3 sm:mb-4 lg:mb-5">Browse, Order & Engage</h3> */}
                  <h3 className="text-xl sm:text-2xl text-start mb-3 sm:mb-4 lg:mb-5">
                    Product Listings
                  </h3>
                  <p className="mb-0 text-start text-gray-600 text-sm sm:text-base max-w-full lg:max-w-[502px]">
                    Users explore categorized product listings, real-time stock
                    info, and detailed product specs. They can place orders
                    directly through the platform, track order history, and
                    receive updates - streamlining the entire purchasing
                    process.
                  </p>
                </div>
              </div>
            </div>

            <div className="step-item-21 flex flex-col lg:flex-row items-center relative">
              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-2 lg:order-1 mt-6 lg:mt-0">
                <div className="step-content">
                  <div className="step-inner grid items-center grid-cols-[80px_1fr] sm:grid-cols-[100px_1fr] lg:grid-cols-[120px_1fr] gap-3 sm:gap-4 lg:gap-5 mb-6 sm:mb-7 lg:mb-9">
                    <div className="icon bg-white border border-[#E0E5EB] shadow-[0px_14px_60px_rgba(20,71,67,0.22)] flex items-center justify-center h-[80px] w-[80px] sm:h-[100px] sm:w-[100px] lg:h-[120px] lg:w-[120px] rounded-full">
                      <img
                        src={step3}
                        alt="icon"
                        className="w-10 sm:w-12 lg:w-auto"
                      />
                    </div>
                    <h2 className="number text-[#398a83] text-start text-[40px] sm:text-[50px] lg:text-[60px] font-bold leading-none">
                      Step 03
                    </h2>
                  </div>
                  {/* <h3 className="text-xl sm:text-2xl text-start mb-3 sm:mb-4 lg:mb-5">Track, Manage & Grow</h3> */}
                  <h3 className="text-xl sm:text-2xl text-start mb-3 sm:mb-4 lg:mb-5">
                    Orders
                  </h3>
                  <p className="mb-0 text-start text-gray-600 text-sm sm:text-base max-w-full lg:max-w-[502px]">
                    Once orders are placed, businesses can track fulfillment,
                    download reports, and analyze trends. Selzor’s reporting
                    tools and API integrations help manage inventory, plan
                    reorders, and scale operations with confidence.
                  </p>
                </div>
              </div>

              <div className="w-full lg:w-1/2 px-2 sm:px-4 order-1 lg:order-2">
                <div className="step-img max-w-full lg:max-w-[628px] w-full h-[240px] sm:h-[320px] lg:h-[400px] rounded-xl sm:rounded-2xl lg:rounded-3xl shadow-[0px_11px_51px_rgba(19,83,77,0.22)]">
                  <img
                    src={stepimg3}
                    alt="step-3"
                    className="w-full h-full object-cover rounded-xl sm:rounded-2xl lg:rounded-3xl border-4 sm:border-6 border-white"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h4 className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
              Our B2B Selzor Categories
            </h4>
            <h2 className="text-gray-600 text-sm xs:text-base sm:text-lg max-w-3xl mx-auto mb-6 sm:mb-8 lg:mb-10">
              Designed to Manage Orders for Every B2B Business
            </h2>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            {courseCategories.map((category, index) => (
              <div
                key={index}
                className="flex items-center gap-3 text-lg font-semibold border border-gray-200 rounded-full py-2 px-5 hover:bg-gray-100 transition duration-300"
              >
                <span className="p-2 rounded-full bg-blue-50 text-[#1a9588]">
                  {category.imgSrc}
                </span>
                {category.name}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto py-12 sm:py-16 md:py-20 px-6 sm:px-5 md:px-0 lg:px-0">
          <div className="flex flex-col gap-6 sm:gap-8">
            <div className="rounded-3xl sm:rounded-[32px] md:rounded-[40px] overflow-hidden flex flex-col items-center h-full lg:px-4 relative">
              {/* Responsive Image */}
              <div className="w-full relative">
                <img
                  src={prizelistImg}
                  alt="Pricing Banner"
                  className="w-full h-[232px] sm:h-[280px] md:h-[390px] lg:h-[780px] object-cover rounded-t-3xl sm:rounded-t-[32px] md:rounded-t-[40px]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent rounded-t-3xl sm:rounded-t-[32px] md:rounded-t-[40px]" />
              </div>

              {/* Content Block */}
              <div className="flex flex-col gap-6 sm:gap-8 pt-0 p-6 sm:p-8 md:p-10 relative z-10 items-center text-center bg-white/80 backdrop-blur-lg rounded-2xl shadow-lg -mt-12 sm:-mt-16 md:-mt-20 w-[90%] sm:w-[80%] md:w-[70%]">
                <div className="flex flex-col items-center gap-2">
                  <h2 className="text-2xl sm:text-3xl md:text-5xl font-semibold text-gray-900 tracking-tight">
                    Upgrade Your Business Experience
                  </h2>
                  <p className="max-w-[470px] text-gray-600 text-base sm:text-lg">
                    Selzor's pricing is straightforward and transparent — no
                    unexpected charges.
                  </p>
                </div>

                {/* CTA Button */}
                <a
                  href="/pricing"
                  className="bg-[#1a9588] text-white hover:bg-[#28b5a6] hover:shadow-xl hover:scale-105 outline-none font-semibold py-4 px-8 rounded-full text-sm sm:text-base min-w-[263px] transition duration-300"
                >
                  Pick Your Plan
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#dbf4f1] py-20">
        <div className=" mx-auto max-w-7xl ">
          <div className="text-center mb-16">
            <h4 className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
              Our Feedbacks
            </h4>
            <h2 className="text-gray-600 text-sm xs:text-base sm:text-lg max-w-3xl mx-auto mb-6 sm:mb-8 lg:mb-10">
              What Our Student's Says
            </h2>
          </div>

          <div className="relative w-full">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={24}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {testimonials2.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="relative rounded-[15px] overflow-hidden z-0 h-full">
                    <div className="absolute top-0 left-0 w-full h-full z-[-1]">
                      <img
                        src={testibg}
                        alt="bg"
                        className="w-full h-full object-cover"
                      />
                    </div>

                    <div className="p-10">
                      <div className="mb-5">
                        <img src={quote} alt="quote" className="w-10 mb-4" />
                        <p className="text-[20px] text-[#162726] leading-relaxed text-start">
                          "{testimonial.text}"
                        </p>
                      </div>
                    </div>

                    <div className="px-2 pt-4 pb-3 flex justify-end">
                      <div className="text-center">
                        <span className="block bg-white text-[#162726] text-sm font-normal border border-[#E0E5EB] border-b-0 py-3 px-7 rounded-t-[10px]">
                          Rating
                        </span>
                        <ul className="flex items-center justify-center bg-[#ECF0F3] px-4 py-2 gap-[2px] border border-[#E0E5EB] border-t-0 rounded-b-[10px] text-[#07a698] text-xs list-none">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <li key={i}>
                              <FaStar />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="absolute bottom-0 left-0 bg-white grid grid-cols-[60px_1fr] items-center gap-[15px] p-[10px_49px_10px_20px] rounded-[15px]">
                      <div className="w-[60px] h-[60px]">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-full h-full object-cover rounded-full"
                        />
                      </div>
                      <div className="text-left">
                        <h4 className="text-[20px] font-semibold mb-0 max-w-36">
                          {testimonial.name}
                        </h4>
                        <span className="text-[14px] font-normal">
                          {testimonial.role}
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto mt-20 px-4 sm:px-6">
          <div className="text-start">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600 text-sm sm:text-base md:text-lg mb-6 sm:mb-8 md:mb-12">
              With advanced analytics and reporting, you can track customer
              behavior, sales trends, & many more to make
            </p>
          </div>

          <div className="space-y-3 sm:space-y-4 text-start">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`rounded-2xl sm:rounded-3xl px-4 sm:px-6 py-3 sm:py-4 md:py-5 transition-colors ${
                    isOpen ? "bg-[#dbf4f1]" : "bg-[#dbf4f1]"
                  }`}
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full flex justify-between items-center text-left text-base sm:text-lg md:text-xl font-medium text-gray-800 focus:outline-none"
                  >
                    <span className="pr-2">{faq.question}</span>
                    <svg
                      className={`w-5 h-5 sm:w-6 sm:h-6 text-gray-600 transform transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </button>
                  {isOpen && (
                    <p className="mt-3 sm:mt-4 md:mt-6 text-gray-700 text-sm sm:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* <section className="relative">
        <div className="bg-[#dbf4f1] mt-20 overflow-hidden">
          <div className="hidden md:block absolute  top-10 right-10 z-10">
            <img src={fullfilorder} alt="shape" />
          </div>
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="w-full lg:w-1/2 mb-8 lg:mb-0 lg:pr-8 flex justify-center lg:justify-start">
                <div className="relative">
                  <img
                    src={Orders}
                    alt="App showcase"
                    className="w-full max-w-[400px] md:max-w-[500px] lg:max-w-none mx-auto lg:mx-0"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2 text-center lg:text-left">
                <div className="mb-6">
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-tight mb-4">
                    Manage and Fulfill Orders On the Go
                  </h2>
                </div>
                <p className="mb-6 text-base md:text-lg text-gray-600">
                  Stay connected with your business anytime, anywhere. Get
                  real-time updates on order status, streamline fulfillment, and
                  ensure seamless customer experiences from any device.
                </p>
                <div className="flex justify-center lg:justify-start space-x-3">
                  <a href="/" className="inline-block">
                    <img
                      src={android}
                      alt="Google Play"
                      className="h-10 md:h-12 rounded-md hover:opacity-90 transition-opacity"
                    />
                  </a>
                  <a href="/" className="inline-block">
                    <img
                      src={apple}
                      alt="App Store"
                      className="h-10 md:h-12 rounded-md hover:opacity-90 transition-opacity"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="relative py-20 bg-[#dbf4f1] mt-20">
        {/* Title */}
        <h2 className="text-center text-2xl md:text-3xl font-extrabold text-gray-800 mb-16">
          Choose between <span className="text-blue-600">Selzor's</span>
          <span className="text-orange-500">Applications</span>
        </h2>

        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-10">
          <div className="bg-white shadow-xl rounded-2xl p-8 flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:shadow-2xl duration-300">
            <img
              src={seller_image}
              alt="Way2Order Branding"
              className=" mb-6 rounded-xl "
            />
            <h3 className="text-xl font-bold text-gray-800 mb-3">Seller</h3>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">
              You, your Sales Reps & your Wholesale Customers download the{" "}
              <span className="font-medium text-blue-600">
                Selzor's Seller App
              </span>{" "}
              (for Android )
            </p>
            <p className="text-xs text-gray-500 mb-4">
              Available for Web, Android
            </p>

            <button className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-6 py-2.5 rounded-xl shadow hover:opacity-90 transition font-medium">
              View Pricing
            </button>
          </div>

          {/* Custom Branding Card */}
          <div className="bg-white shadow-xl rounded-2xl p-8 flex flex-col items-center text-center transition transform hover:-translate-y-2  duration-300">
            <img
              src={buyer_images}
              alt="Custom Branding"
              className=" mb-6 rounded-xl"
            />
            <h3 className="text-xl font-bold text-gray-800 mb-3">Buyer</h3>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">
              You, your Sales Reps & your Wholesale Customers download{" "}
              <span className="font-medium text-orange-500">
                Your Buyer App
              </span>{" "}
              (for Android )
            </p>
            <p className="text-xs text-gray-500 mb-4">
              Available for Web, Android
            </p>

            <button className="bg-gradient-to-r from-orange-500 to-orange-400 text-white px-6 py-2.5 rounded-xl shadow hover:opacity-90 transition font-medium">
              Learn More
            </button>
          </div>
        </div>

        {/* Decorative Background */}
        <div className="absolute top-10 left-10 w-40 h-40 bg-blue-100 rounded-full blur-3xl opacity-50 -z-10"></div>
        <div className="absolute bottom-10 right-10 w-52 h-52 bg-orange-100 rounded-full blur-3xl opacity-50 -z-10"></div>
      </section>

      <Contact />
      <FloatingButton />
      <Footer />
    </div>
  );
};

export default GlobleComponent;
